import client from '@/api/client';
import { BASE_URL } from '@/constants';

export default {
	//파라미터가 없을경우
	// getTableList: () => {
	//파라미터가 있을경우
	getTableList: (tableId, tableNm, colId, colNm) => {
		let url = `${BASE_URL}/tableInfo/v1/tableList?tableName=${tableName}&tbComment=${tbComment}&colId=${colName}&colNm=${colComment}`;
		return client
			.get(url)
			.then(response => (response && response.data) || null)
			.catch(error => console.log(error));
	},
	selectOptions: () => {
		return client.get(`${BASE_URL}/tableInfo/v1/options`).then(res => res.data);
	},

	selectCommCdTypeList: ({ commCdType, useYn, currentPage, pageUnit, commCdTypeName }) => {
		const params = { commCdTypeName, pageUnit, currentPage };
		const queryString =
			'?' +
			Object.entries(params)
				.map(([key, val]) => (!_.isNil(val) ? `${key}=${val}` : ''))
				.filter(r => r)
				.join('&');
		return client.get(`${BASE_URL}/commonCode/v1/commCdType/${commCdType}/useYn/${useYn}` + queryString).then(res => res.data);
	},
	selectCommCdList: ({ commCdType, currentPage, pageUnit }) =>
		client
			.get(`${BASE_URL}/commonCode/v1/commCdType/${commCdType}/commCd?currentPage=${currentPage}&pageUnit=${pageUnit}`)
			.then(res => res.data),

	/*
	select: ({ searchParams, currentPage, pageUnit }) => {
		let queryStr = '';
		if (searchParams.tableName !== undefined || searchParams.tbComment !== undefined) {
			queryStr = comm.objectToQuerystring({
				tableName: searchParams.tableName,
				tbComment: searchParams.tbComment,
				colName: searchParams.colName,
				colComment: searchParams.colComment,
				currentPage,
				pageUnit
			});
		}
		console.log('queryStr ::: ' + queryStr);
		return client
			.get(`${BASE_URL}/tableInfo/v1/select` + queryStr)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	*/

	select: params => {
		//console.log(params);
		const queryParams = Object.entries(params)
			.filter(([key, val]) => val)
			.map(([key, val]) => `${key}=${val}`)
			.join('&');
		//console.log(queryParams);
		return client.get(`${BASE_URL}/tableInfo/v1/tables?${queryParams}`).then(res => res.data);
	},
	getUseYnList: (plantCd, commCdType) =>
		client.post(`${BASE_URL}/cc/v1/plants/${plantCd}/commonCodes?commCdType=${commCdType}`).then(res => res.data)
};
